import { Laya } from "../../Laya";
import { Loader } from "../net/Loader";
import { URL } from "../net/URL";
import { TextureFormat } from "../RenderEngine/RenderEnum/TextureFormat";
import { Utils } from "../utils/Utils";
import { SpineTemplet } from "./SpineTemplet";
import { SpineTexture } from "./SpineTexture";
const _premultipliedAlpha = true;
const _srgb = true;
class SpineTempletLoader {
    load(task) {
        let atlasUrl = Utils.replaceFileExtension(task.url, "atlas");
        return Promise.all([
            task.loader.fetch(task.url, task.ext == "skel" ? "arraybuffer" : "json", task.progress.createCallback()),
            task.loader.fetch(atlasUrl, "text", task.progress.createCallback())
        ]).then(res => {
            if (!res[0] || !res[1])
                return null;
            let templet = new SpineTemplet();
            let version = SpineTemplet.RuntimeVersion;
            if (version == "4.1") {
                templet.needSlot = true;
            }
            if (version.startsWith('4.'))
                return this.parseAtlas4(res[0], res[1], task, templet);
            else
                return this.parseAtlas3(res[0], res[1], task, templet);
        });
    }
    parseAtlas3(desc, atlasText, task, templet) {
        var _a;
        let atlasPages = [];
        let basePath = URL.getPath(task.url);
        let atlas = new spine.TextureAtlas(atlasText, (path) => {
            let url = basePath + path;
            atlasPages.push({
                url, type: Loader.TEXTURE2D,
                propertyParams: {
                    premultiplyAlpha: _premultipliedAlpha
                },
                constructParams: [0, 0, TextureFormat.R8G8B8A8, false, false, _srgb, _premultipliedAlpha]
            });
            return new SpineTexture(null);
        });
        return Laya.loader.load(atlasPages, null, (_a = task.progress) === null || _a === void 0 ? void 0 : _a.createCallback()).then((res) => {
            let textures = {};
            let premultipliedAlpha = true;
            for (var i = 0; i < res.length; i++) {
                let tex = res[i];
                if (tex)
                    tex._addReference();
                let pages = atlas.pages;
                let page = pages[i];
                premultipliedAlpha = page.pma || (tex._premultiplyAlpha && premultipliedAlpha);
                page.texture.realTexture = tex;
                page.texture.setFilters(page.minFilter, page.magFilter);
                page.texture.setWraps(page.uWrap, page.vWrap);
                page.width = page.texture.getImage().width;
                page.height = page.texture.getImage().height;
                textures[page.name] = tex;
            }
            let regions = atlas.regions;
            for (const region of regions) {
                let page = region.page;
                region.u = region.x / page.width;
                region.v = region.y / page.height;
                if (region.rotate) {
                    region.u2 = (region.x + region.height) / page.width;
                    region.v2 = (region.y + region.width) / page.height;
                }
                else {
                    region.u2 = (region.x + region.width) / page.width;
                    region.v2 = (region.y + region.height) / page.height;
                }
            }
            templet._parse(desc, atlas, textures, premultipliedAlpha);
            return templet;
        });
    }
    parseAtlas4(desc, atlasText, task, templet) {
        var _a;
        let atlas = new spine.TextureAtlas(atlasText);
        let basePath = URL.getPath(task.url);
        return Laya.loader.load(atlas.pages.map((page) => {
            return {
                url: basePath + page.name,
                type: Loader.TEXTURE2D,
                propertyParams: {
                    premultiplyAlpha: _premultipliedAlpha
                },
                constructParams: [0, 0, TextureFormat.R8G8B8A8, false, false, _srgb, _premultipliedAlpha]
            };
        }), null, (_a = task.progress) === null || _a === void 0 ? void 0 : _a.createCallback()).then((res) => {
            let textures = {};
            let pages = atlas.pages;
            let premultipliedAlpha = true;
            for (let i = 0, len = res.length; i < len; i++) {
                let tex = res[i];
                if (tex)
                    tex._addReference();
                let page = pages[i];
                premultipliedAlpha = page.pma || (tex._premultiplyAlpha && premultipliedAlpha);
                textures[page.name] = tex;
                page.setTexture(new SpineTexture(tex));
            }
            templet._parse(desc, atlas, textures, premultipliedAlpha);
            return templet;
        });
    }
}
Loader.registerLoader(["skel"], SpineTempletLoader, Loader.SPINE);
